import Vue from 'vue'
import Router from 'vue-router'
// 异步组件，按需加载 - https://cn.vuejs.org/v2/guide/components-dynamic-async.html#%E5%BC%82%E6%AD%A5%E7%BB%84%E4%BB%B6
// const main = () => import(/* webpackChunkName:'login' */'../views/main')
// 路由标识
// expert -> 专家团
// ranking -> 学霸版
// course -> 课程
// live -> 直播
// user -> 个人中心
// study -> 学习
// classify -> 分类
// subscribe -> 约课
// vip -> vip
// primary -> 入门
// index -> 首页
Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    // 首页
    {
      path: '/investor-education-manager/wap/',
      name: 'index.index',
      component: () => import('../views/home/index.vue'),
      meta: {
        title: '首页',
        footerType: true,
        bgColor: 'f7f7f7',
        tabVal: 0,
        appTitle: '投教课堂'
      }
    },
    { // 入门
      path: '/investor-education-manager/wap/primary',
      name: 'primary.primaryIndex',
      component: () => import('../views/home/index.vue'),
      meta: {
        title: '入门',
        bgColor: 'fff',
        tabVal: 1,
        appTitle: '投教课堂'
      }
    },
    { // 进阶
      path: '/investor-education-manager/wap/advanced',
      name: 'advanced.advancedIndex',
      component: () => import('../views/home/index.vue'),
      meta: {
        title: '进阶',
        bgColor: 'fff',
        tabVal: 2,
        appTitle: '投教课堂'
      }
    },
    { // 高级
      path: '/investor-education-manager/wap/senior',
      name: 'senior.seniorIndex',
      component: () => import('../views/home/index.vue'),
      meta: {
        title: '高级',
        bgColor: 'fff',
        tabVal: 3,
        appTitle: '投教课堂'
      }
    },
    { // vip
      path: '/investor-education-manager/wap/vip',
      component: () => import('../views/vip/layout.vue'),
      children: [{
        // vip
        path: '',
        name: 'vip.vipIndex',
        component: () => import('../views/vip/index'),
        meta: {
          title: 'VIP'
        }
      },
      {
        // 详情
        path: 'detail',
        name: 'vip.vipDetail',
        component: () => import('../views/vip/detail'),
        meta: {
          title: 'VIP详情',
          bgColor: 'f7f7f7'
        }
      }]
    },
    { // 搜索
      path: '/investor-education-manager/wap/search',
      name: 'search.searchIndex',
      component: () => import('../views/home/search'),
      meta: {
        title: '搜索',
        bgColor: 'f7f7f7',
        appTitle: '投教课堂'
      }
    },
    { // 约课
      path: '/investor-education-manager/wap/subscribe',
      name: 'subscribe.subscribeIndex',
      component: () => import('../views/home/subscribe'),
      meta: {
        title: '约课',
        bgColor: 'f7f7f7',
        appTitle: '约课'
      }
    },
    { // 专家团
      path: '/investor-education-manager/wap/expert',
      component: () => import('../views/expert/layout.vue'),
      children: [
        {
          // 专家团列表
          path: '',
          name: 'expert.expertIndex',
          component: () => import('../views/expert/index'),
          meta: {
            title: '专家列表',
            appTitle: '专家团'
          }
        },
        {
          // 专家团详情
          path: 'detail/:id(\\d+)',
          name: 'expert.expertDetail',
          component: () => import('../views/expert/detail'),
          meta: {
            title: '专家详情',
            appTitle: '专家团'
          }
        },
        {
          // 专家团详情播放页
          path: 'column/:columnId/article/:articleId(\\d+)',
          name: 'expert.expertArticle',
          component: () => import('../views/expert/play'),
          meta: {
            title: '专家详情-播放页'
          }
        },
        {
          // 专家团详情播放页(微信分享落地页)
          path: 'column-share/:columnId/article/:articleId(\\d+)',
          name: 'expert.shareExpertArticle',
          component: () => import('../views/expert/playShare'),
          meta: {
            title: '热门专栏'
          }
        },
        {
          // 每日复盘
          path: 'everyDayReplay',
          name: 'expert.everydayReplay',
          component: () => import('../views/expert/everydayReplay'),
          meta: {
            title: '每日复盘',
            bgColor: 'f7f7f7',
            appTitle: '每日复盘'
          }
        },
      ]
    },
    { // 分类
      path: '/investor-education-manager/wap/classify',
      name: 'classify.classifyIndex',
      component: () => import('../views/classify'),
      meta: {
        title: '分类',
        appTitle: '精品课程'
      }
    },
    // 学霸排行榜
    {
      path: '/investor-education-manager/wap/ranking',
      name: 'ranking.rankingIndex',
      component: () => import('../views/home/ranking.vue'),
      meta: {
        title: '学霸排行榜'
      }
    },
    {  // 课程详情
      path: '/investor-education-manager/wap/course/:course_id(\\d+)',
      name: 'course.courseIndex',
      component: () => import('../views/course/index.vue'),
      meta: {
        title: '课程',
        bgColor: 'fff'
      }
    },
    {  // 课程详情(分享落地页)
      path: '/investor-education-manager/wap/course-share/:course_id(\\d+)',
      name: 'course.courseShareDetail',
      component: () => import('../views/course/shareDeatil.vue'),
      meta: {
        title: '课程',
        bgColor: 'fff'
      }
    },
    {  // 课程列表
      path: '/investor-education-manager/wap/course/course-list',
      name: 'course.courseList',
      component: () => import('../views/course/courseList'),
      meta: {
        title: '课程',
        bgColor: 'f7f7f7',
        appTitle: '热门课程'
      }
    },
    {  // 支付
      path: '/investor-education-manager/wap/course/circle-pay',
      name: 'course.courseCirclePay',
      component: () => import('../views/course/circlePay'),
      meta: {
        title: '支付',
        bgColor: 'f7f7f7'
      }
    },
    {  // 课程问答
      path: '/investor-education-manager/wap/course/chat',
      name: 'course.courseChat',
      component: () => import('../views/course/chat'),
      meta: {
        title: '课程问答',
        bgColor: 'f7f7f7'
      }
    },
    // 学习
    {
      path: '/investor-education-manager/wap/study',
      name: 'study.studyIndex',
      component: () => import('../views/study/index.vue'),
      meta: {
        title: '学习'
      }
    },
    // 学习计划
    {
      path: '/investor-education-manager/wap/studyPlan',
      name: 'study.studyPlan',
      component: () => import('../views/study/studyPlan.vue'),
      meta: {
        title: '学习计划',
        bgColor: 'f7f7f7',
        appTitle: '学习计划'
      }
    },
    // 直播
    {
      path: '/investor-education-manager/wap/live',
      component: () => import('../views/live/layout.vue'),
      children: [
        // 首页
        {
          path: '',
          name: 'live.liveIndex',
          component: () => import('../views/live/index.vue'),
          meta: {
            title: '直播'
          }
        },
        // 历史
        {
          path: 'history',
          name: 'live.liveHistory',
          component: () => import('../views/live/history.vue'),
          meta: {
            title: '历史'
          }
        },
        // 视频直播
        {
          path: 'video-live/:courseId(\\d+)',
          name: 'live.liveVideoLive',
          component: () => import('../views/live/videoLive.vue'),
          meta: {
            title: '视频直播'
          }
        },
        // 音频直播
        {
          path: 'audio-live/:courseId(\\d+)',
          name: 'live.liveAudioLive',
          component: () => import('../views/live/audioLive.vue'),
          meta: {
            title: '音频直播'
          }
        }
      ]
    },
    // 个人中心
    {
      path: '/investor-education-manager/wap/user',
      component: () => import('../views/user/layout.vue'),
      children: [
        // 首页
        {
          path: '',
          name: 'user.userIndex',
          component: () => import('../views/user/index.vue'),
          meta: {
            title: '个人中心',
            footerType: true,
            bgColor: 'f7f7f7'
          }
        },
        // 基本资料
        {
          path: 'information',
          name: 'user.userInformation',
          component: () => import('../views/user/information.vue'),
          meta: {
            title: '基本资料',
            bgColor: 'f7f7f7'
          }
        },
        // 基本资料修改
        {
          path: 'information/edit-:type',
          name: 'user.editUserInformation',
          component: () => import('../views/user/editInformation.vue'),
          meta: {
            title: '基本资料修改',
            bgColor: 'f7f7f7'
          }
        },
        // 实名认证
        {
          path: 'real-name',
          name: 'user.userRealName',
          component: () => import('../views/user/realName.vue'),
          meta: {
            title: '实名认证',
            bgColor: 'f7f7f7'
          }
        },
        // 我的消息
        {
          path: 'my-news',
          name: 'user.userMyNews',
          component: () => import('../views/user/myNews.vue'),
          meta: {
            title: '我的消息'
          }
        },
        // 我的消息--详情
        {
          path: 'my-news/detail/:id(\\d+)',
          name: 'user.userMyNewsDetail',
          component: () => import('../views/user/myNewsDetail.vue'),
          meta: {
            title: '消息详情'
          }
        },
        // 我的公告---详情
        {
          path: 'my-notices/detail/:id(\\d+)',
          name: 'user.userMyNoticesDetail',
          component: () => import('../views/user/myNoticesDetail.vue'),
          meta: {
            title: '公告详情'
          }
        },
        // 我的订单
        {
          path: 'order-list',
          name: 'user.userOrderList',
          component: () => import('../views/user/orderList.vue'),
          meta: {
            title: '我的订单',
            bgColor: 'f7f7f7'
          }
        },
        // 我的订单---去支付详情页
        {
          path: 'order-list/pay-detail/:id',
          name: 'user.userOrderPayDetail',
          component: () => import('../views/user/orderPayDetail.vue'),
          meta: {
            title: '支付详情',
            bgColor: 'f7f7f7'
          }
        },
        // 我的订单---支付成功页
        {
          path: 'order-list/pay-success/:id',
          name: 'user.userOrderPaySuccess',
          component: () => import('../views/user/orderPaySuccess.vue'),
          meta: {
            title: '支付成功',
            bgColor: 'fff'
          }
        },
        // 我的课程顾问
        {
          path: 'my-adviser-chat',
          name: 'user.userMyAdviserChat',
          component: () => import('../views/user/myAdviserChat.vue'),
          meta: {
            title: '我的课程顾问',
            bgColor: 'f7f7f7'
          }
        }
      ]
    },
    // 404
    {
      path: '*',
      name: 'error.error404',
      component: () => import('../views/error/error404.vue'),
      meta: {
        title: '404'
      }
    },
    // 500
    {
      path: '/investor-education-manager/wap/error500',
      name: 'error.error500',
      component: () => import('../views/error/error500.vue'),
      meta: {
        title: '500'
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js